const Footer = () => {
  return (
    <footer className="bg-card text-card-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} Zuto. All rights reserved.
          </p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a 
              href="https://firebasestorage.googleapis.com/v0/b/taprecorder-456414.firebasestorage.app/o/policy%2Fpolicy.html?alt=media&token=27221fda-0d94-458e-a8ed-82b0e8e470be" 
              className="text-muted-foreground hover:text-foreground transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <a 
              href="https://firebasestorage.googleapis.com/v0/b/taprecorder-456414.firebasestorage.app/o/policy%2FtermsAndConditions.html?alt=media&token=edcd15f5-3081-4254-bc1a-4be7f0801e3e" 
              className="text-muted-foreground hover:text-foreground transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;